import React from 'react';
import { Modal, Button, Alert, Badge, Typography } from 'antd';
import { ClockCircleOutlined, SaveOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

interface SessionIdleModalProps {
  open: boolean;
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const SessionIdleModal: React.FC<SessionIdleModalProps> = ({
  open,
  saving,
  onCancel,
  onSave,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      centered
      closable={false}
      maskClosable={false}
      width={480}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ClockCircleOutlined style={{ color: '#faad14', fontSize: 18 }} />
          <Badge
            count="Session idle"
            style={{
              backgroundColor: '#fff7e6',
              color: '#d46b08',
              border: '1px solid #ffd591',
              fontWeight: 600,
              fontSize: 12,
              borderRadius: 4,
            }}
          />
        </div>
      }
      styles={{
        header: {
          backgroundColor: '#fffbe6',
          marginLeft: '-24px',
          marginRight: '-24px',
          marginTop: '-20px',
          paddingLeft: '24px',
          paddingRight: '24px',
          paddingTop: '16px',
          paddingBottom: '16px',
          borderBottom: '1px solid #ffe58f',
        },
      }}
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            borderTop: '1px solid #f0f0f0',
            paddingTop: 16,
            marginLeft: '-24px',
            marginRight: '-24px',
            paddingLeft: '24px',
            paddingRight: '24px',
            marginBottom: '-20px',
            paddingBottom: '20px',
          }}
        >
          <Button onClick={onCancel} disabled={saving}>
            Cancel
          </Button>
          <Button
            type="primary"
            icon={<SaveOutlined />}
            loading={saving}
            onClick={onSave}
          >
            Save progress
          </Button>
        </div>
      }
    >
      <div style={{ paddingTop: 8, paddingBottom: 8 }}>
        <Title level={5} style={{ marginTop: 0, marginBottom: 8 }}>
          Your session is idle
        </Title>
        <Paragraph style={{ marginBottom: 16, color: '#595959' }}>
          You've been inactive for 5 minutes. Please save your changes to preserve your work progress.
        </Paragraph>
        <Alert
          message="Your progress will not be saved if you cancel."
          type="warning"
          showIcon
        />
      </div>
    </Modal>
  );
};

export default SessionIdleModal;
